import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-43434186"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "sub-menu"
};
const _hoisted_2 = {
  style: {
    "margin-left": "8px"
  }
};
import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
const __default__ = {
  name: 'SubMenu'
};
function setup(__props) {
  const props = __props;
  const route = useRoute();
  const isActive = computed(() => props.currentRoute.children.some(child => child.path.startsWith(route.path)));
  const subVisable = ref(true);
  function changeSubMemu() {
    subVisable.value = !subVisable.value;
  }
  return (_ctx, _cache) => {
    const _component_Ex_icon = _resolveComponent("Ex-icon");
    const _component_svg_icon = _resolveComponent("svg-icon");
    return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
      class: _normalizeClass(["sub-menu-title", {
        active: _unref(isActive)
      }]),
      onClick: changeSubMemu
    }, [_createVNode(_component_Ex_icon, {
      icon: __props.currentRoute.meta?.icon,
      size: 18
    }, null, 8, ["icon"]), _createElementVNode("span", _hoisted_2, _toDisplayString(__props.currentRoute.meta?.title), 1), subVisable.value ? (_openBlock(), _createBlock(_component_svg_icon, {
      key: 0,
      icon: "menu-up",
      class: "icon",
      color: "#BBBBBB",
      size: 18
    })) : (_openBlock(), _createBlock(_component_svg_icon, {
      key: 1,
      icon: "menu-down",
      class: "icon",
      color: "#BBBBBB",
      size: 18
    }))], 2), _withDirectives(_createElementVNode("div", null, [_renderSlot(_ctx.$slots, "default")], 512), [[_vShow, subVisable.value]])]);
  };
}
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    currentRoute: {
      type: null,
      required: true,
      default: {}
    }
  },
  setup
});